/* ===========================================================================
   VJ-CORR-D172 — L'AGENDA DES LIVES, LU UNE FOIS, PARTAGÉ PARTOUT
   6 septembre 2026
   ---------------------------------------------------------------------------
   Rachid : « la bandelette tout en haut doit être remplacée par le compte à
   rebours de notre prochain live. »

   LA CONTRAINTE QUI DICTE CE FICHIER. Les six dates de Live vivent dans
   `templates/page.live.json`, blocs `live_1` à `live_6`, et Rachid les saisit
   depuis l'éditeur Shopify. Une section Liquid ne peut PAS lire les réglages
   d'une autre section : le bandeau d'annonce, servi sur toutes les pages, n'a
   aucun moyen côté serveur de connaître la prochaine date.

   D146 avait déjà résolu le problème pour la section « Le prochain live » de
   l'accueil : `sections/live-shopping.liquid` publie son calendrier dans un
   `<script type="application/json" data-vj-events>`, et la section va le
   chercher par un `fetch` de la page Live. Une seule saisie, deux affichages.

   Le bandeau étant sur TOUTES les pages, refaire ce fetch page par page serait
   une requête de trop à chaque vue. Ce module le fait donc UNE fois par
   session, garde le résultat dans `sessionStorage`, et sert tout le monde :
   - s'il est déjà sur la page Live, il lit le JSON sur place, sans requête ;
   - sinon il regarde le cache de session ;
   - sinon il tire la page Live, une seule fois même si trois appelants
     demandent en même temps (la promesse est mémorisée).

   CE QUE CE COMPTE À REBOURS N'EST PAS. CLAUDE.md §2.4 interdit « les tactiques
   d'urgence, la fausse rareté, les comptes à rebours de panique ». Un rendez-
   vous public et gratuit annoncé à l'avance n'est rien de tout cela : il
   informe, il ne presse pas. D'où le parti pris tenu ici — pas de rouge, pas
   de clignotement, pas de « vite », pas de compte à rebours sur un PRIX ni sur
   un STOCK. Les mêmes chiffres posés sur une promotion seraient une faute ;
   posés sur l'heure d'une émission, ils sont un service.

   Rollback : retirer la ligne de `layout/theme.liquid`, le bloc
   `compte_a_rebours` de `sections/announcement-bar.liquid`, et ce fichier.
   =========================================================================== */
(function () {
  'use strict';

  var CLE = 'vj-agenda-live';
  var DUREE_CACHE = 30 * 60 * 1000; /* une demi-heure : une date de live ne
                                       change pas deux fois dans une visite */
  var SOURCE_PAR_DEFAUT = '/pages/live-shopping';
  /* VJ-CORR-D334 — un live dure. Relevé le 13 septembre à 17 h : le bandeau
     annonçait encore « c'est en direct maintenant » pour le live de 14 h,
     pendant que la page Live comptait déjà vers vendredi. Un rendez-vous est
     « en direct » pendant deux heures après son début, puis il est passé et
     le suivant prend sa place. */
  var DUREE_LIVE = 2 * 60 * 60 * 1000;

  /* ── LA LECTURE ────────────────────────────────────────────────────────── */

  function analyser(brut) {
    try {
      var l = JSON.parse(brut);
      return Object.prototype.toString.call(l) === '[object Array]' ? l : [];
    } catch (e) {
      return [];
    }
  }

  function lireDans(doc) {
    var s = (doc || document).querySelector('[data-vj-events]');
    return s ? analyser(s.textContent) : null;
  }

  function memoire() {
    try {
      return window.sessionStorage;
    } catch (e) {
      return null; /* navigation privée, cookies refusés : on s'en passe */
    }
  }

  function enCache() {
    var m = memoire();
    if (!m) return null;
    try {
      var o = JSON.parse(m.getItem(CLE) || 'null');
      if (!o || typeof o.t !== 'number') return null;
      if (Date.now() - o.t > DUREE_CACHE) return null;
      return o.e || [];
    } catch (e) {
      return null;
    }
  }

  function poserEnCache(ev) {
    var m = memoire();
    if (!m) return;
    try {
      m.setItem(CLE, JSON.stringify({ t: Date.now(), e: ev }));
    } catch (e) {
      /* quota plein : le fetch se refera, ce n'est pas grave */
    }
  }

  var enCours = null;

  function agenda(url) {
    var surPlace = lireDans(document);
    if (surPlace && surPlace.length) return Promise.resolve(surPlace);

    var garde = enCache();
    if (garde) return Promise.resolve(garde);

    if (enCours) return enCours;

    enCours = fetch(url || SOURCE_PAR_DEFAUT, { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.text() : Promise.reject(r.status);
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ev = lireDans(doc) || [];
        poserEnCache(ev);
        return ev;
      })
      .catch(function () {
        return []; /* le repli écrit côté serveur reste à l'écran */
      });

    return enCours;
  }

  /* ── LE PROCHAIN RENDEZ-VOUS ───────────────────────────────────────────────
     Même règle que D146 : on compare à MINUIT, pas à l'instant présent. Un live
     prévu ce soir à 20 h doit encore compter comme « le prochain » à 9 h du
     matin. L'heure, elle, sert à l'égrenage une fois la date retenue. */

  function heureDe(txt) {
    var m = /(\d{1,2})\s*[:hH]\s*(\d{2})?/.exec(String(txt || ''));
    if (!m) return { h: 20, min: 0 }; /* le rythme des lives Vinteji est le soir */
    return { h: Math.min(23, +m[1]), min: m[2] ? Math.min(59, +m[2]) : 0 };
  }

  function prochain(evenements) {
    var minuit = new Date();
    minuit.setHours(0, 0, 0, 0);
    var futurs = [];
    for (var i = 0; i < (evenements || []).length; i++) {
      var e = evenements[i] || {};
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(e.date || '').trim());
      if (!m) continue;
      var jour = new Date(+m[1], +m[2] - 1, +m[3]);
      if (jour < minuit) continue;
      var hm = heureDe(e.time);
      var debut = new Date(+m[1], +m[2] - 1, +m[3], hm.h, hm.min, 0, 0);
      if (debut.getTime() + DUREE_LIVE <= Date.now()) continue; /* D334 : fini */
      futurs.push({
        jour: jour,
        instant: new Date(+m[1], +m[2] - 1, +m[3], hm.h, hm.min, 0, 0),
        d: +m[3],
        mois: +m[2] - 1,
        annee: +m[1],
        time: e.time,
        title: e.title,
        platform: e.platform,
        link: e.link,
        /* VJ-CORR-D540 — la photo du live voyage avec lui : le carré du
           dépliant et le médaillon du bandeau portent la même que la bulle
           du calendrier (vide = l'affiche carrée de la maison, posée côté
           Liquid). */
        image: e.image || '',
        image2x: e.image2x || '',
        /* VJ-CORR-D580 — une AFFICHE de plateforme (Whatnot) n'est pas une photo de
           live : elle se cadre entière, comme celle de la maison. */
        affiche: e.affiche || '',
        verticale: e.verticale || ''
      });
    }
    futurs.sort(function (a, b) {
      return a.instant - b.instant;
    });
    return futurs[0] || null;
  }

  window.VJAgendaLive = { agenda: agenda, prochain: prochain };

  /* ── LE BANDEAU QUI ÉGRÈNE ────────────────────────────────────────────────
     Un élément personnalisé, pour que le bandeau reste déclaratif côté Liquid
     et que le rechargement de section de l'éditeur Shopify le reconstruise
     tout seul. */

  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
              'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function deuxChiffres(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function quandEnToutesLettres(ev) {
    var hm = heureDe(ev.time);
    var heure = hm.min ? hm.h + ' h ' + deuxChiffres(hm.min) : hm.h + ' h';
    return JOURS[ev.jour.getDay()] + ' ' + ev.d + ' ' + MOIS[ev.mois] + ', ' + heure;
  }

  /* VJ-CORR-D334 — le bandeau à la fashionica écrit la date deux fois : en
     toutes lettres sur ordinateur, abrégée sur téléphone. Les deux sont dans
     le DOM, la feuille choisit ; le jour de la semaine abrégé porte sa propre
     classe pour pouvoir sortir sous 380 px. */
  /* D547 — les noms des plateformes, écrits comme sur la page Live */
  var PLATEFORMES = { instagram: 'Instagram', tiktok: 'TikTok', ebay: 'eBay', whatnot: 'Whatnot' };
  var JOURS_COURTS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MOIS_COURTS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin',
                     'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

  function span(classe, texte) {
    var e = document.createElement('span');
    e.className = classe;
    e.textContent = texte;
    return e;
  }

  function poserQuand(cible, ev) {
    var hm = heureDe(ev.time);
    var heure = hm.min ? hm.h + ' h ' + deuxChiffres(hm.min) : hm.h + ' h';
    var jour = ev.jour.getDay();
    while (cible.firstChild) cible.removeChild(cible.firstChild);
    cible.appendChild(span('vj-long', JOURS[jour] + ' ' + ev.d + ' ' + MOIS[ev.mois] + ' · ' + heure));
    var court = span('vj-court', '');
    court.appendChild(span('vj-rebours__jsem', JOURS_COURTS[jour] + ' '));
    court.appendChild(document.createTextNode(ev.d + ' ' + MOIS_COURTS[ev.mois] + ' · ' + heure));
    cible.appendChild(court);
  }

  function definir() {
    if (window.customElements && !customElements.get('vinteji-rebours-live')) {
      customElements.define(
        'vinteji-rebours-live',
        (function () {
          function Rebours() {
            return Reflect.construct(HTMLElement, [], Rebours);
          }
          Rebours.prototype = Object.create(HTMLElement.prototype);
          Rebours.prototype.constructor = Rebours;
          Object.setPrototypeOf(Rebours, HTMLElement);

          Rebours.prototype.connectedCallback = function () {
            if (this.amorce) return;
            this.amorce = true;
            var self = this;
            agenda(this.getAttribute('data-vj-source')).then(function (ev) {
              self.evenements = ev;
              var p = prochain(ev);
              if (p) self.installer(p);
            });
          };

          Rebours.prototype.disconnectedCallback = function () {
            if (this.horloge) clearInterval(this.horloge);
          };

          Rebours.prototype.installer = function (ev) {
            var vif = this.querySelector('[data-vj-vif]');
            var repli = this.querySelector('[data-vj-repli]');
            var quand = this.querySelector('[data-vj-quand]');
            var dit = this.querySelector('[data-vj-dit]');
            if (!vif) return;

            if (quand) {
              if (this.classList.contains('vj-rebours--bandeau')) poserQuand(quand, ev);
              else quand.textContent = quandEnToutesLettres(ev);
            }
            /* VJ-CORR-D547 — le médaillon porte la photo du live (sinon l'affiche
               de la maison posée côté Liquid, qu'on garde pour y revenir), et le
               sur-titre dit sur quelle plateforme. */
            var photo = this.querySelector('[data-vj-photo]');
            if (photo) {
              if (photo.getAttribute('data-vj-photo-maison') === null) {
                photo.setAttribute('data-vj-photo-maison', photo.style.getPropertyValue('--vj-rebours-photo'));
              }
              if (ev.image) {
                photo.style.setProperty('--vj-rebours-photo', "url('" + String(ev.image).replace(/'/g, '%27') + "')");
                /* D580 : l'affiche Whatnot garde le cadrage de l'affiche de la maison */
                photo.classList.toggle('is-photo-live', !ev.affiche);
              } else {
                photo.style.setProperty('--vj-rebours-photo', photo.getAttribute('data-vj-photo-maison'));
                photo.classList.remove('is-photo-live');
              }
            }
            var plateforme = this.querySelector('[data-vj-plateforme]');
            if (plateforme) {
              var nom = PLATEFORMES[String(ev.platform || '').toLowerCase()] || '';
              plateforme.textContent = nom ? 'sur ' + nom : '';
            }
            if (this.horloge) clearInterval(this.horloge);

            /* Ce que le lecteur d'écran entend : une phrase qui ne bouge pas.
               Les chiffres qui s'égrènent sont, eux, `aria-hidden` côté Liquid.
               Une minuterie annoncée à la seconde noierait tout le reste. */
            if (dit) {
              dit.textContent =
                'Prochain live le ' + quandEnToutesLettres(ev) + '.';
            }

            if (repli) repli.hidden = true;
            vif.hidden = false;
            this.setAttribute('data-vj-etat', 'date');

            var cases = {
              j: this.querySelector('[data-vj-j]'),
              h: this.querySelector('[data-vj-h]'),
              m: this.querySelector('[data-vj-m]'),
              s: this.querySelector('[data-vj-s]')
            };

            var self = this;
            function battre() {
              var reste = ev.instant - Date.now();
              if (reste <= 0) {
                /* D334 — passé la fenêtre du direct, le rendez-vous est fini :
                   on passe au suivant au lieu de rester « en direct » jusqu'à
                   minuit. */
                if (-reste >= DUREE_LIVE) {
                  if (self.horloge) clearInterval(self.horloge);
                  var suivant = prochain(self.evenements || []);
                  if (suivant) {
                    self.remettre();
                    self.installer(suivant);
                  }
                  return;
                }
                if (self.getAttribute('data-vj-etat') === 'en-direct') return;
                /* Le rendez-vous est commencé. On ne compte pas à l'envers :
                   on le dit, et le lien vaut alors une invitation. */
                self.setAttribute('data-vj-etat', 'en-direct');
                var d = self.querySelector('[data-vj-direct]');
                if (d) d.hidden = false;
                var t = self.querySelector('[data-vj-minuterie]');
                if (t) t.hidden = true;
                var titre = self.querySelector('[data-vj-titre]');
                if (titre) titre.textContent = 'En direct';
                if (dit) dit.textContent = 'Le live est en direct maintenant.';
                return;
              }
              var s = Math.floor(reste / 1000);
              var j = Math.floor(s / 86400);
              var h = Math.floor((s % 86400) / 3600);
              var m = Math.floor((s % 3600) / 60);
              var sec = s % 60;
              /* « 00 J » n'apprend rien et occupe six caractères. Le jour ne
                 s'affiche qu'à partir du moment où il en reste un. */
              if (self.jourVisible !== (j > 0)) {
                self.jourVisible = j > 0;
                var paire = self.querySelectorAll('[data-vj-paire-j]');
                for (var k = 0; k < paire.length; k++) paire[k].hidden = j === 0;
              }
              if (cases.j) cases.j.textContent = deuxChiffres(j);
              if (cases.h) cases.h.textContent = deuxChiffres(h);
              if (cases.m) cases.m.textContent = deuxChiffres(m);
              if (cases.s) cases.s.textContent = deuxChiffres(sec);
            }
            battre();
            this.horloge = setInterval(battre, 1000);
          };

          /* D334 — retour à l'état « à venir » avant d'installer le suivant. */
          Rebours.prototype.remettre = function () {
            this.setAttribute('data-vj-etat', 'date');
            var d = this.querySelector('[data-vj-direct]');
            if (d) d.hidden = true;
            var t = this.querySelector('[data-vj-minuterie]');
            if (t) t.hidden = false;
            var titre = this.querySelector('[data-vj-titre]');
            if (titre && titre.getAttribute('data-vj-titre-avant')) {
              titre.textContent = titre.getAttribute('data-vj-titre-avant');
            }
          };

          return Rebours;
        })()
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', definir);
  } else {
    definir();
  }
})();
